/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../common/checking/onboarding_source';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "service": {
            "nested": {
              "v1": {
                "nested": {
                  "Flow": {
                    "fields": {
                      "context": {
                        "type": "bytes",
                        "id": 1,
                        "rule": "optional"
                      },
                      "setPasscode": {
                        "type": ".squareup.bbfrontend.service.v1.Flow.SetPasscode",
                        "id": 2
                      },
                      "debitCardActivation": {
                        "type": ".squareup.bbfrontend.service.v1.Flow.DebitCardActivation",
                        "id": 3
                      },
                      "unitNotificationPreferences": {
                        "type": ".squareup.bbfrontend.service.v1.Flow.UnitNotificationPreferencesFlow",
                        "id": 4
                      },
                      "checkingOnboarding": {
                        "type": ".squareup.bbfrontend.service.v1.Flow.CheckingOnboarding",
                        "id": 5
                      },
                      "debitCardLinking": {
                        "type": ".squareup.bbfrontend.service.v1.Flow.DebitCardLinking",
                        "id": 6
                      },
                      "billingAddressUpdate": {
                        "type": ".squareup.bbfrontend.service.v1.Flow.BillingAddressUpdate",
                        "id": 7
                      },
                      "debitCardAtmLimits": {
                        "type": ".squareup.bbfrontend.service.v1.Flow.DebitCardATMLimitsFlow",
                        "id": 8
                      }
                    },
                    "nested": {
                      "SetPasscode": {
                        "fields": {
                          "cardToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "unitToken": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "source": {
                            "type": ".squareup.bbfrontend.service.v1.Flow.SetPasscode.Source",
                            "id": 3,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "Source": {
                            "values": {
                              "DO_NOT_USE": 0,
                              "MAILER_ACTIVATION": 1
                            }
                          }
                        }
                      },
                      "DebitCardActivation": {
                        "fields": {
                          "unitToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "cardToken": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "UnitNotificationPreferencesFlow": {
                        "fields": {
                          "unitToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "CheckingOnboarding": {
                        "fields": {
                          "unitToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "source": {
                            "type": ".squareup.bbfrontend.common.checking.Source",
                            "id": 2,
                            "rule": "optional"
                          },
                          "capabilities": {
                            "type": ".squareup.bbfrontend.service.v1.Flow.CheckingOnboarding.ClientCapability",
                            "id": 3,
                            "rule": "repeated"
                          },
                          "orderType": {
                            "type": ".squareup.bbfrontend.service.v1.Flow.CheckingOnboarding.OrderType",
                            "id": 4,
                            "rule": "optional",
                            "options": {
                              "default": "ORDER_PRIMARY_CARD"
                            }
                          },
                          "kybApiVersion": {
                            "type": "int32",
                            "id": 5,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "ClientCapability": {
                            "values": {
                              "CLIENT_CAPABILITIES_DO_NOT_USE": 0,
                              "CLIENT_CAPABILITIES_ADD_TO_DIGITAL_WALLET": 1
                            }
                          },
                          "OrderType": {
                            "values": {
                              "ORDER_PRIMARY_CARD": 0,
                              "ORDER_ADDITIONAL_CARD": 1
                            }
                          }
                        }
                      },
                      "DebitCardLinking": {
                        "fields": {
                          "unitToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "source": {
                            "type": ".squareup.bbfrontend.service.v1.Flow.DebitCardLinking.Source",
                            "id": 2,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "Source": {
                            "values": {
                              "DO_NOT_USE": 0,
                              "SETTINGS_TRANSFERS_ADD_CARD": 1,
                              "SETTINGS_TRANSFERS_CHANGE_CARD": 2,
                              "BALANCE_ADD_MONEY": 3,
                              "BALANCE_INSTANT_TRANSFER": 4,
                              "BALANCE_TRANSFER_TO_BANK": 5
                            }
                          }
                        }
                      },
                      "BillingAddressUpdate": {
                        "fields": {
                          "unitToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "cardToken": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "cardKind": {
                            "type": ".squareup.bbfrontend.service.v1.Flow.BillingAddressUpdate.CardKind",
                            "id": 3,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "CardKind": {
                            "values": {
                              "DEBIT": 0,
                              "CREDIT": 1
                            }
                          }
                        }
                      },
                      "DebitCardATMLimitsFlow": {
                        "fields": {
                          "cardToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "flow_type": {
                        "oneof": ["setPasscode", "debitCardActivation", "unitNotificationPreferences", "checkingOnboarding", "debitCardLinking", "billingAddressUpdate", "debitCardAtmLimits"]
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.Flow && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.Flow?.nested?.SetPasscode && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.Flow?.nested?.SetPasscode?.nested?.Source && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.Flow?.nested?.DebitCardActivation && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.Flow?.nested?.UnitNotificationPreferencesFlow && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.Flow?.nested?.CheckingOnboarding && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.Flow?.nested?.CheckingOnboarding?.nested?.ClientCapability && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.Flow?.nested?.CheckingOnboarding?.nested?.OrderType && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.Flow?.nested?.DebitCardLinking && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.Flow?.nested?.DebitCardLinking?.nested?.Source && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.Flow?.nested?.BillingAddressUpdate && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.Flow?.nested?.BillingAddressUpdate?.nested?.CardKind && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.Flow?.nested?.DebitCardATMLimitsFlow) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE Flow @ squareup/bbfrontend/v1/flow.proto at 13:1
 */
export const Flow = $root.lookupType('squareup.bbfrontend.service.v1.Flow');
fixType(Flow);
Builder.createAndAttachToType(Flow);
/**
 * SOURCE SetPasscode @ squareup/bbfrontend/v1/flow.proto at 26:3
 */
Flow.SetPasscode = $root.lookupType('squareup.bbfrontend.service.v1.Flow.SetPasscode');
fixType(Flow.SetPasscode, {
  cardToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(Flow.SetPasscode);
/**
 * SOURCE Source @ squareup/bbfrontend/v1/flow.proto at 39:5
 */
Flow.SetPasscode.Source = $root.lookupEnum('squareup.bbfrontend.service.v1.Flow.SetPasscode.Source').values;
/**
 * SOURCE DebitCardActivation @ squareup/bbfrontend/v1/flow.proto at 46:3
 */
Flow.DebitCardActivation = $root.lookupType('squareup.bbfrontend.service.v1.Flow.DebitCardActivation');
fixType(Flow.DebitCardActivation, {
  unitToken: {
    notEmpty: true
  },
  cardToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(Flow.DebitCardActivation);
/**
 * SOURCE UnitNotificationPreferencesFlow @ squareup/bbfrontend/v1/flow.proto at 51:3
 */
Flow.UnitNotificationPreferencesFlow = $root.lookupType('squareup.bbfrontend.service.v1.Flow.UnitNotificationPreferencesFlow');
fixType(Flow.UnitNotificationPreferencesFlow, {
  unitToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(Flow.UnitNotificationPreferencesFlow);
/**
 * SOURCE CheckingOnboarding @ squareup/bbfrontend/v1/flow.proto at 55:3
 */
Flow.CheckingOnboarding = $root.lookupType('squareup.bbfrontend.service.v1.Flow.CheckingOnboarding');
fixType(Flow.CheckingOnboarding, {
  unitToken: {
    notEmpty: true
  },
  source: {
    required: true
  }
});
Builder.createAndAttachToType(Flow.CheckingOnboarding);
/**
 * SOURCE ClientCapability @ squareup/bbfrontend/v1/flow.proto at 73:5
 */
Flow.CheckingOnboarding.ClientCapability = $root.lookupEnum('squareup.bbfrontend.service.v1.Flow.CheckingOnboarding.ClientCapability').values;
/**
 * SOURCE OrderType @ squareup/bbfrontend/v1/flow.proto at 78:5
 */
Flow.CheckingOnboarding.OrderType = $root.lookupEnum('squareup.bbfrontend.service.v1.Flow.CheckingOnboarding.OrderType').values;
/**
 * SOURCE DebitCardLinking @ squareup/bbfrontend/v1/flow.proto at 84:3
 */
Flow.DebitCardLinking = $root.lookupType('squareup.bbfrontend.service.v1.Flow.DebitCardLinking');
fixType(Flow.DebitCardLinking, {
  unitToken: {
    notEmpty: true
  },
  source: {
    required: true
  }
});
Builder.createAndAttachToType(Flow.DebitCardLinking);
/**
 * SOURCE Source @ squareup/bbfrontend/v1/flow.proto at 85:5
 */
Flow.DebitCardLinking.Source = $root.lookupEnum('squareup.bbfrontend.service.v1.Flow.DebitCardLinking.Source').values;
/**
 * SOURCE BillingAddressUpdate @ squareup/bbfrontend/v1/flow.proto at 105:3
 */
Flow.BillingAddressUpdate = $root.lookupType('squareup.bbfrontend.service.v1.Flow.BillingAddressUpdate');
fixType(Flow.BillingAddressUpdate, {
  cardToken: {
    notEmpty: true
  },
  cardKind: {
    required: true
  }
});
Builder.createAndAttachToType(Flow.BillingAddressUpdate);
/**
 * SOURCE CardKind @ squareup/bbfrontend/v1/flow.proto at 110:5
 */
Flow.BillingAddressUpdate.CardKind = $root.lookupEnum('squareup.bbfrontend.service.v1.Flow.BillingAddressUpdate.CardKind').values;
/**
 * SOURCE DebitCardATMLimitsFlow @ squareup/bbfrontend/v1/flow.proto at 116:3
 */
Flow.DebitCardATMLimitsFlow = $root.lookupType('squareup.bbfrontend.service.v1.Flow.DebitCardATMLimitsFlow');
fixType(Flow.DebitCardATMLimitsFlow, {
  cardToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(Flow.DebitCardATMLimitsFlow);